<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_table_of_contents_1">Pour Elizabeth et Zahra, avec qui j’ai partagé beaucoup de dîners spéciaux. Et pour Maurice, Paul et Florent – quels que soient leurs véritables noms – pour avoir rendu ces soirées encore plus inoubliables.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?3198e645